import React from 'react';
import {Alert, Button, Col, CustomInput, Row} from 'reactstrap';
//import images
import check from '../assets/images/check.png';
import VISA from '../assets/images/payments/visa.png'
import americanExpress from '../assets/images/payments/american-ex.png'
import discover from '../assets/images/payments/discover.png'
import MasterCard from '../assets/images/payments/master-card.png'
import paypal from '../assets/images/payments/paypal.png'
import {useSelector} from 'react-redux';

const AutoPayConfirmation = () => {

  const CCData = useSelector(state => state.paymentMethods);
  const {saveName, ccExpMonth, ccExpYear, CCTypeId, ccNum} = CCData.cardPaymentMethod;

  return (
    <>
      <div className="d-flex justify-content-center align-items-center mt-100" style={{minHeight: '100vh'}}>
        <section className="section mt-100 ">
          <div className="rounded shadow-lg p-4 position-relative">
            <Alert color="info" className="text-center ">
              <p className="m-2"><img src={check} alt=""/></p>
              <h3>Payment Method Submitted Successfully</h3>
            </Alert>
            <Col className="col-12 m-5">
              <h5>Saved as {saveName}</h5>
              <h5>
                {CCTypeId ? <img src={CCTypeId === '4' ? VISA : MasterCard} alt="cc type"/> : 'Credit Card: '}
                ********{ccNum.slice(-4)}</h5>
              <h5>Exp: {ccExpMonth}/{ccExpYear}</h5>
            </Col>
            <Col className="d-flex justify-content-center">
              <h4>This payment method will be used in our new system</h4>
            </Col>
          </div>

        </section>
      </div>
    </>
  );
};


export default AutoPayConfirmation;
